// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"MobileSearchInput_searchInputWrapper__NgVyL","hintText":"MobileSearchInput_hintText__BmK3b"};